export const ENDPOINTS = {
  geneCoverageData: '/gene_cov_deadzone_parsed_results.csv',
  panelToGenesMappingData: '/panel_to_genes.json',
};
